/**
 * @import {Route} from "./route.jsdoc.js"
 */

import UserConsoleLayout from '@/views/kpi/layout/userConsoleLayout.vue';

/**
 * 绩效咨询公司用户路由表
 * @type {[Route]} - 绩效公司，第三方公司路由表
 */
export const consultantRoutes = [
    {
        path: '/enterprise/sys-setting/partner-org-list',
        page: () => import('@/views/kpi/enterprise/org-partner/my-org-partner-list.vue'),
        layout: [ UserConsoleLayout ],
        title: '合作伙伴管理',
        roles: [ 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '系统设置', '合作伙伴管理' ],
        icon: [ 'vxe-icon-setting', '' ],
    },
    {
        path: '/kpi/proj-kpi-audit/audit-task-list',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/my-org-proj-kpi-waiting-audit-list1.vue'),
        layout: [ UserConsoleLayout ],
        title: '待审核绩效申报表',
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效申报表管理', '待审核绩效表' ],
        icon: [ 'vxe-icon-signature', '' ],
    },
    {
        title: '审核中绩效申报表',
        path: '/kpi/proj-kpi-audit/auditing-list',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/my-org-proj-kpi-auditing-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效申报表管理', '审核中绩效表' ],
        icon: [ 'vxe-icon-signature', '' ],
    },
    {
        title: '项目绩效申报表审核',
        path: '/kpi/proj-kpi-audit/kpi-table-edit/:level/:projId',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/proj-kpi-table-editor.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        path: '/kpi/proj-kpi-audit/audited-list',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/my-org-proj-kpi-audited-list.vue'),
        layout: [ UserConsoleLayout ],
        title: '审核完成绩效申报表',
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效申报表管理', '审核完成' ],
        icon: [ 'vxe-icon-signature', '' ],
    },
    {
        title: '绩效绩效表审核日志',
        path: '/kpi/proj-kpi-audit/proj-audit-log/:projId',
        page: () => import('@/views/kpi/enterprise/proj-kpi-audit-log-list/proj-kpi-audit-log-list.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '项目绩效申报表',
        path: '/kpi/proj-kpi/declare/proj-list',
        page: () => import('@/views/kpi/kpi-build/proj-kpi/proj-kpi-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效全过程', '项目绩效申报表' ],
        icon: [ 'vxe-icon-folder', '' ],
    },
    {
        title: '项目绩效监控',
        path: '/kpi/proj-kpi/monitor/proj-list',
        page: () => import('@/views/kpi/kpi-monitor/proj-monitor/proj-kpi/proj-kpi.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        history: true,
        closable: true,
        menu: [ '绩效全过程', '项目绩效监控' ],
        icon: [ 'vxe-icon-folder', '' ],
    },
    {
        title: '项目绩效自评',
        path: '/kpi/proj-kpi/appraise/proj-list',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/scoring/index.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效全过程', '项目绩效自评' ],
        icon: [ 'vxe-icon-folder', '' ],
    },
    {
        title: '项目绩效监控清单',
        path: '/kpi/proj-kpi/monitor/pro-monitor-list/:projId',
        page: () => import('@/views/kpi/kpi-monitor/proj-monitor/kpi-monitor-list/kpi-monitor-list.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '项目绩效监控表',
        path: '/kpi/proj-kpi/monitor/monitor-detail/:pmId',
        page: () => import('@/views/kpi/kpi-monitor/proj-monitor/kpi-monitor/kpi-monitor.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '项目绩效自评',
        path: '/kpi/proj-kpi/appraise/appraise-home',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/home/appraise-home.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '绩效自评表查阅',
        path: '/kpi/proj-kpi/appraise/scoring-detail/:id',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/scoring/scoring.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '绩效自评权重设置',
        path: '/kpi/proj-kpi/appraise/weight-setting-detail/:id',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/weight-setting/weight-setting.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '绩效自评表权重设置',
        path: '/kpi/proj-kpi/appraise/weight-setting',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/weight-setting/index.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
];
